var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-bottom-sheet', {
    attrs: {
      "full-width": ""
    },
    model: {
      value: _vm.sheet,
      callback: function callback($$v) {
        _vm.sheet = $$v;
      },
      expression: "sheet"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "green",
      "dark": ""
    },
    on: {
      "click": function click($event) {
        return _vm.requestFullscreen();
      }
    },
    slot: "activator"
  }, [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")]), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-2"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n            "), _c('v-spacer'), _c('v-icon', {
    attrs: {
      "color": "red",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.sheet = false;
      }
    }
  }, [_vm._v("close")])], 1), _c('v-card-text', {
    staticClass: "py-0 my-0"
  }, [this.saving === false ? _c('VueSignaturePad', {
    ref: "signaturePad",
    staticClass: "signaturePad",
    attrs: {
      "height": "60vh",
      "width": "100%"
    }
  }) : _c('v-progress-circular', {
    attrs: {
      "size": 100,
      "width": 10,
      "color": "primary",
      "indeterminate": ""
    }
  })], 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "bottom": "",
      "color": "red",
      "dark": "",
      "fab": "",
      "left": ""
    },
    on: {
      "click": _vm.undo
    }
  }, [_c('v-icon', [_vm._v("undo")])], 1), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "bottom": "",
      "color": "green",
      "dark": "",
      "fab": "",
      "right": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }